import { components } from '@/common/bag-api';
import { CamelCaseKeys } from '@/common/types/snake-to-camel-case';

export enum RoomKind {
	NAME_OPTION = 3,
	NO_NAME_OPTION = 4,
	TOUR_OPTION = 5,
	NAME_CONFIRMED = 6,
	NO_NAME_CONFIRMED = 7,
	TOUR_OPTION_CONFIRMED = 8,
}

export enum ProductKind {
	TRIP = 'Wypoczynek',
	EXPRESS = 'Ekspres',
	ROUND_TRIP = 'Objazdówka',
	NO_NAME = 'NoName',
}

export enum Colors {
	PINK = 'rgba(255, 51, 255, 0.9)',
	YELLOW = 'rgba(255, 255, 0, 0.9)',
	ORANGE = 'rgba(255, 128, 0, 0.9)',
	LIGHT_BLUE = 'rgba(0, 255, 255, 0.9)',
	BLUE = 'rgba(0, 128, 255, 0.9)',
	LIGHT_GREEN = 'rgba(191, 255, 0, 0.9)',
	GREEN = 'rgba(0, 255, 0, 0.9)',
	RED = 'rgba(233, 5, 0, 0.9)',
	PURPLE = 'rgba(210, 145, 188, 0.9)',
	BEIGE = 'rgba(255, 223, 211, 0.9)',
}

export enum StateKind {
	LOCKED = 'L',
	SELL_BLOCKED = 'S',
	RESERVED = 'R',
}

export enum AvailabilityKind {
	STATE = 'state',
	AVAILABILITY = 'availability',
}

export interface Selected {
	date: string;
	destination: Destination | null;
	products: number[];
}

export interface Destination {
	id: number;
	name: string;
}

export interface Month {
	days: number;
	from: number;
	name: string;
}

export interface DialogData {
	id: number;
	istourreservationSet: IstourreservationSet[];
	offerSlot: OfferSlot[];
	reservation: string[];
	data: Data[];
	room: number;
	dateRange: DateRange;
	state: string;
	comment: string;
	product: Product;
}

export interface IstourreservationSet {
	errorRoomGuarantee: boolean;
	id: number;
	isTourCapacity: number;
	isTourId: number;
	kind: number;
	personCount: number;
	roomAvailabilityState: number;
	roomCount: number;
	roomGuarantee: string;
	status: number;
	viewGuarantee: boolean;
}

export interface Data {
	comment: string;
	dateRange: DateRange;
	id: number;
	istourreservationSet: IstourreservationSet[];
	notes: string[];
	offerSlot: OfferSlot[];
	product: number;
	reservation: number[];
	reservationofferSet: number[];
	room: number;
	roomType: any;
	state: string;
	stateLabel: string;
	styles: CSSStyleDeclaration;
}

export interface DateRange {
	bounds: string;
	lower: string;
	upper: string;
}

export interface OfferSlot {
	id: number;
	userData: UserData;
}

export type Users = {
	firstName: string;
	lastName: string;
	birthDate: string;
	phone: string[];
	businessCaseId: string;
};

export interface UserData {
	birth: string;
	firstName: string;
	lastName: string;
	userAddresses: userAddresses[];
	userContacts: UserContacts[];
}

export interface userAddresses {
	zipCode: string;
	address: string;
}

export interface UserContacts {
	destiny: Destiny;
	phone: string;
	email: string;
}

export interface Destiny {
	id: string;
	destiny: string;
}

export interface Room {
	id: number;
}

export interface ReservationOffer {
	id: number;
	dateFrom: string;
	dateTo: string;
}

export type ProductRoomAvailabilityResult = components['schemas']['PaginatedRoomAvailabilityReadList'];

export type ProductRoomSlaveAvailabilityResult = components['schemas']['PaginatedRoomSlaveAvailabilityList'];

export type ProductRoomAvailabilityStateResult = components['schemas']['PaginatedRoomAvailabilityStateReadList'];

export type Product = CamelCaseKeys<components['schemas']['AccommodationFileProduct']>;
